import CheckBoxLabelHookForm from "components/CheckBoxLabelHookForm";
import TextInputLabelHookForm from "components/TextInputLabelHookForm";
import React, { useState } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { useRecoilValue } from "recoil";
import { IModel } from "../types";
import { editStateModel } from "../atoms/atoms";
import SelectHookFormSingle from "components/SelectHookFormSingle";
import { useGetLeasedEquipmentMake } from "../hooks/useGetLeasedEquipmentMake";

export const ModelDetails = (props: {
  setChanges: React.Dispatch<React.SetStateAction<boolean>>;
  data: IModel | undefined;
}) => {
  // Props drilled
  const { data, setChanges } = props;

  // Recoil Hook
  const edit = useRecoilValue(editStateModel);

  // Form Functions
  const { register } = useFormContext();
  const formMethods = useFormContext();

  // Local Hooks

  const [inputData, setInputData] = useState(data?.modelName || "");
  const [inputData2, setInputData2] = useState(data?.description || "");
  const [checkBoxChanges, setCheckBoxChanges] = useState(data?.isActive);
  const [dropBoxChanges, setDropBoxChanges] = useState(data?.makeId || "");

  const { data: make, isLoading: makeLoading } = useGetLeasedEquipmentMake();

  const makeOptions = make?.data.map((x) => {
    return {
      label: x.makeName,
      value: x.makeId,
    };
  });

  const allMakeOpt = makeOptions && [...makeOptions];

  return (
    <>
      <div className="bg-bgDB">
        <div className="m-2 bg-white box-shadow h-full">
          <div className="grid grid-cols-4 mx-3 pb-2 gap-2 gap-x-6 py-2">
            <div className="col-span-2 my-1">
              <TextInputLabelHookForm
                name="modelName"
                label="Model Name"
                type="text"
                onChange={(e) => {
                  setInputData(e.target.value);

                  if (
                    e.target.value.trim() === "" ||
                    inputData2.trim() === "" ||
                    (e.target.value === data?.modelName &&
                      inputData2 == data?.description &&
                      dropBoxChanges == data?.makeId &&
                      checkBoxChanges == data?.isActive)
                  ) {
                    setChanges(false);
                  } else {
                    setChanges(true);
                  }
                  e.target.value = e.target.value.replace(/\s+/g, " ");
                }}
                required={true}
                className={
                  formMethods.formState.errors.modelName &&
                  formMethods.formState.errors.modelName.message &&
                  "border-2 border-red-500 col-span-2 "
                }
                register={formMethods.register("modelName", {
                  required: {
                    value: true,
                    message: "Required Field",
                  },
                })}
                maxLength={255}
              />
            </div>
            <div className="col-span-2 my-1">
              <TextInputLabelHookForm
                name="description"
                label="Description"
                type="text"
                onChange={(e) => {
                  setInputData2(e.target.value);
                  if (
                    e.target.value.trim() === "" ||
                    inputData.trim() === "" ||
                    (e.target.value === data?.description &&
                      inputData == data?.modelName &&
                      dropBoxChanges == data?.makeId &&
                      checkBoxChanges == data?.isActive)
                  ) {
                    setChanges(false);
                  } else {
                    setChanges(true);
                  }
                  e.target.value = e.target.value.replace(/\s+/g, " ");
                }}
                required={true}
                className={
                  formMethods.formState.errors.description &&
                  formMethods.formState.errors.description.message &&
                  "border-2 border-red-500 col-span-2 "
                }
                register={formMethods.register("description", {
                  required: {
                    value: true,
                    message: "Required Field",
                  },
                })}
                maxLength={255}
              />
            </div>

            <div className="col-span-2 my-1">
              <Controller
                name="makeId"
                control={formMethods.control}
                rules={{ required: true }}
                render={({ field }) => (
                  <SelectHookFormSingle
                    placeHolder={data?.makeName}
                    isClearable={false}
                    field={field}
                    onChange={(e) => {
                      field.onChange(e ? e.value : null);
                      setDropBoxChanges(e.value);
                      if (
                        e.value === 0 ||
                        inputData.trim() === "" ||
                        inputData2.trim() === "" ||
                        (e.value === data?.makeId &&
                          inputData2 == data?.description &&
                          inputData == data.modelName &&
                          checkBoxChanges == data.isActive)
                      ) {
                        setChanges(false);
                      } else {
                        setChanges(true);
                      }
                    }}
                    value={field.value}
                    isLoading={makeLoading}
                    options={allMakeOpt}
                    label="Make Name"
                    className={
                      formMethods.formState.errors.state &&
                      "border-2 border-red-500 col-span-2 "
                    }
                    required={true}
                  />
                )}
              />
            </div>

            {edit && (
              <div className="col-span-2 my-1">
                <CheckBoxLabelHookForm
                  name="isActive"
                  label={
                    checkBoxChanges
                      ? "Uncheck to Deactivate"
                      : "Check to Activate"
                  }
                  type="checkbox"
                  validation={{
                    required: {
                      value: false,
                      message: "Required Field",
                    },
                  }}
                  onClick={(e) => {
                    setCheckBoxChanges(e.target.checked);

                    if (
                      inputData?.trim() === "" ||
                      inputData2.trim() === "" ||
                      (e.target.checked === data?.isActive &&
                        inputData2 == data?.description &&
                        dropBoxChanges == data.makeId &&
                        inputData == data.modelName)
                    ) {
                      setChanges(false);
                    } else {
                      setChanges(true);
                    }
                  }}
                  register={register}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ModelDetails;
